module.exports = __webpack_public_path__ + "static/img/4nieok.297f2e53.webp";